export default "__VITE_ASSET__15828fe4__"